var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWishlistIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.306C0 6.05183 1.38206 7.46671 3.08576 7.46671H7.29002V3.16034C7.29002 1.41451 5.90905 0 4.20498 0C1.88268 0 0 1.92803 0 4.306ZM0.24432 9.06417C0.312569 9.05822 0.381182 9.05525 0.450521 9.05525H7.412V20H3.77334C1.97489 20 0.490454 18.6223 0.27191 16.8408V13.8026C0.265828 13.8026 0.259582 13.8023 0.253392 13.802L0.253347 13.802L0.24432 13.8015V9.06417ZM9.66751 20V9.05525H16.5281C16.6322 9.05525 16.735 9.06231 16.8355 9.07607V13.7837L16.8294 13.7846L16.8228 13.7855V16.3912C16.8228 18.3843 15.2451 20 13.2993 20H9.66751ZM9.70998 7.46634V3.16034C9.70998 1.41451 11.0924 0 12.7957 0C15.1177 0 17 1.92803 17 4.30638C17 6.0522 15.619 7.46671 13.915 7.46671H9.71071L9.70998 7.46634Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlistIcon);
export default __webpack_public_path__ + "static/media/wishlist-icon.f60b6214931a96d38f468ea66b81bed4.svg";
export { ForwardRef as ReactComponent };